import { get } from "lodash";

export const buildMappedProduct = (insurancePlan) => ({
  id: get(insurancePlan, "id"),
  name: get(insurancePlan, "name"),
  alias: get(insurancePlan, "alias"),
  externalId: get(insurancePlan, "externalId") || "",
});
